var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container py-5"},[_c('MessageCard',{attrs:{"type":"error","message":"Page Not Found"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }